import Color from "color";
export default function determineBlackOrWhiteTextColor(c) {
  try {
    return Color(c).isLight() ? "#000000" : "#FFFFFF";
  } catch (e) {
    console.error("Error in color parsing:", e);
    return "#000000";
  }
}
